<template>
    <div class="player-mod">
        <video-player ref="videoPlayer" class="vjs-custom-skin"
            :options="playerOptions"
            :playsinline="true"
            @ready="playerReadied($event)"
            @canplay="onPlayerCanplay($event)"
            @error="onPlayerError($event)"></video-player>
    </div>
</template>

<script>

import 'video.js/dist/video-js.css';

import 'vue-video-player/src/custom-theme.css';

import { videoPlayer } from 'vue-video-player';

import 'video.js';

export default {

    components: {

        videoPlayer

    },

    props: {

        videoUrl: {
            type: String,
            required: true
        },
        coverUrl: {
            type: String,
            required: true
        }

    },

    computed: {

        player () {

            return this.$refs.videoPlayer.player;

        }

    },

    data () {

        return {

            playerOptions: {
                height: '',
                width: '',
                autoplay: false,
                sources: [{

                    type: 'video/mp4',
                    src: this.videoUrl

                }],
                poster: this.coverUrl
            },
            currentUrl: this.videoUrl,
            timeoutCount: 0

        };

    },

    methods: {

        playerReadied ( player ) {

            console.log( 'play' );

        },

        onPlayerCanplay ( ) {

            this.timeoutCount = 0;

        },

        onPlayerError () {

            if ( this.timeoutCount < 5 ) {

                this.playerOptions.sources[0].src = this.currentUrl;
                this.timeoutCount++;

            }
            
        },

        switchVideoUrl ( url ) {

            let myPlayer = this.$refs.videoPlayer.player;

            myPlayer.src( url );

            this.playerOptions.sources[0].src = url;
                
        }

    },

    watch: {

        videoUrl ( val ) {

            this.switchVideoUrl( val );

            this.currentUrl = val;
            
        },

        coverUrl ( val ) {

            this.playerOptions.poster = val;

        }

    }

};

</script>

<style lang="less">

    @linear-background: linear-gradient( 90deg , @theme-linear-gradient-start , @theme-linear-gradient-end );
    #player .player-mod,.video-player.vjs-custom-skin,.video-js{
        width: 100%;
        height: 100%;
    }
    #player .video-js .vjs-play-progress{
        background: @linear-background;
    }
    #player .video-js .vjs-slider{
        background-color: #bfc7d3;

    }
    #player .video-js .vjs-load-progress{
        background: #fff;
    }

    #player .video-js .vjs-control-bar{
        margin-bottom: .2rem;
        background-color: transparent;
        height: .3rem;
        padding: 0 .2rem;
    }

    #player .video-js .vjs-progress-holder .vjs-play-progress{
        color: @theme;
    }

    #player .vjs-icon-fullscreen-enter:before, #player .video-js .vjs-fullscreen-control .vjs-icon-placeholder:before{
        font-family: 'icomoon' !important;
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        content: "\e9b8";
        font-size: .24rem;
        position: relative;
        top: -.02rem;
    }

    #player .video-js .vjs-volume-level:before {
        position: absolute;
        font-size: .9em;
        height: .14rem;
        width: .04rem;
        border-radius: 2px;
        background-color: #f5f5f5;
        content: "";
        top: -.04rem;
        right: 0;
    }

    #player .vjs-custom-skin > .video-js .vjs-big-play-button{
        font-size: .3rem;
    }
    #player .vjs-custom-skin > .video-js .vjs-big-play-button .vjs-icon-placeholder:before{
        font-size: .6rem;
    }

    #player .vjs-icon-play:before, #player .video-js .vjs-big-play-button .vjs-icon-placeholder:before, #player .video-js .vjs-play-control .vjs-icon-placeholder:before,
    #player .vjs-icon-pause:before, #player .video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder:before,
    #player .vjs-icon-replay:before, #player .video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder:before{
        font-family: 'icomoon' !important;
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        content: "\e9b5";
        font-size: .3rem;
    }

    #player .vjs-icon-pause:before, #player .video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder:before{
        content: "\e9bd";
    }

    #player .video-js .vjs-progress-control{ max-width: 68%; }
    #player .video-js .vjs-time-control{ line-height: .3rem; }
    #player .vjs-time-control.vjs-time-divider,
    #player .vjs-duration.vjs-time-control.vjs-control{
        display: none !important;
    }
    #player .vjs-current-time.vjs-time-control.vjs-control{
        position: absolute;
        left: 77%;
    }
    #player .vjs-menu-button-popup .vjs-menu{ display: block; }
    #player .vjs-menu-button-popup .vjs-menu .vjs-menu-content{
        background-color: transparent;
    }
    #player .video-js .vjs-volume-level{
        background: @linear-background;
        border-radius: 2px;
        height: .04rem;
    }
    #player .vjs-button > .vjs-icon-placeholder:before{
        line-height: normal;
    }

    #player .video-js .vjs-volume-panel .vjs-volume-control{
        height: .3rem;
        visibility: visible;
        opacity: 1;
        width: .84rem !important;
        border-radius: 2px;
        margin-right: 0;
    }
    #player .vjs-progress-control.vjs-control{
        position: absolute;
        width: 68% !important;
        left: .8rem;
    }

    #player .vjs-volume-panel.vjs-control.vjs-volume-panel-horizontal{
        position: absolute;
        left: 83%;
    }

    #player .video-js .vjs-mute-control{
        position: relative;
        top: .02rem;
    }

    #player .video-js .vjs-volume-bar{
        margin-top: .12rem;
    }

    #player .vjs-custom-skin > .video-js .vjs-control{
        width: .4rem;
    }

    #player .video-js .vjs-mute-control{
        padding-right: 0;
    }

    #player .vjs-fullscreen-control.vjs-control{
        position: absolute;
        right: .45rem;
    }

    #player .video-js .vjs-big-play-button{
        border: none;
        background-color: transparent !important;
    }

    #player .video-player:hover .vjs-big-play-button{
        color: @theme;
    }

    #player .video-js .vjs-progress-holder .vjs-play-progress, #player .video-js .vjs-progress-holder .vjs-load-progress, #player .video-js .vjs-progress-holder .vjs-load-progress div{
        border-radius: 2px;
        height: .04rem;
    }

    #player .vjs-poster{
        background-size: cover;
    }

    #player .video-js{
        width: 100%;
        height: 100%;
    }

    #player .video-js .vjs-progress-holder{
        height: .04rem;
        margin: 0;
        border-radius: 2px;
    }

    #player .vjs-custom-skin > .video-js .vjs-play-progress:before {
        top: -.04rem;
        font-size: .9em;
    }

    #player .vjs-volume-bar.vjs-slider-horizontal{
        height: .04rem;
        border-radius: 2px;
    }

    @media screen and ( max-width: 1199px ) {

        #player .vjs-custom-skin > .video-js .vjs-play-progress:before{
            top: -.08rem;
        }

        #player .vjs-slider-horizontal .vjs-volume-level{
            height: .04rem;
        }

        #player .video-js .vjs-volume-level:before {
            height: 0.26rem;
        }

        #player .play-area{ width: 100%;  overflow-x: hidden; }

        #player.player-mod main .video{
            width: 100%;
            height: calc( 100vw * 660 / 1200 );
        }

        #player.player-mod .video{
            margin-bottom: .44rem;
        }

        #player .vjs-button > .vjs-icon-placeholder:before{
            line-height: .3rem;
            font-size: .4rem;
        }

        #player .vjs-progress-control.vjs-control{
            width: 3rem !important;
            top: -.04rem;
        }

        #player .video-js .vjs-control-bar{
            height: .4rem;
            padding: 0 15px;
            font-size: .26rem !important;
        }

        #player .vjs-current-time.vjs-time-control.vjs-control{
            left: 4.2rem;
            font-size: .26rem;
            color: #f5f5f5;
            width: .6rem;
        }

        #player .vjs-volume-panel.vjs-control.vjs-volume-panel-horizontal{
            left: 5.2rem;
        }

        #player .vjs-volume-bar.vjs-slider-horizontal{
            width: .8rem !important;
            height: .04rem;
            margin: 0;
            top: .16rem;
            margin-left: .15rem;
            border-radius: 2px;
        }

        #player .vjs-fullscreen-control.vjs-control{
            left: unset;
            right: 15px;
            top: -.05rem;
        }

        #player .video-js .vjs-volume-panel .vjs-volume-control{
            top: -.02rem;
            margin-right: 0;
            width: auto !important;
        }

        #player .video-js .vjs-volume-level:before {
            content: '';
            position: absolute;
            font-size: 0.9em;
            height: .18rem;
            width: .04rem;
            border-radius: 2px;
            background-color: #f5f5f5;
            top: -0.06rem;
            right: 0;
        }

        #playe .vjs-custom-skin > .video-js .vjs-play-progress:before{
            top: -.09rem;
        }

    }

    @media screen and ( min-width: 780px ) and (  max-width: 900px ) {

        #player .vjs-progress-control.vjs-control{
            width: 3.4rem !important;
        }

        #player .vjs-current-time.vjs-time-control.vjs-control {
            left: 4.5rem;
        }

        #player .vjs-volume-panel.vjs-control.vjs-volume-panel-horizontal {
            left: 5.6rem;
        }

    }

    @media screen and ( min-width: 900px ) and (  max-width: 1199px ) {

        #player .vjs-progress-control.vjs-control{
            width: 5.8rem !important;
        }

        #player .vjs-current-time.vjs-time-control.vjs-control {
            left: 7rem;
        }

        #player .vjs-volume-panel.vjs-control.vjs-volume-panel-horizontal {
            left: 8rem;
        }

    }

    @media screen and ( max-width: 320px ) {

        #player .video-js .vjs-volume-level:before {
            top: -0.3em;
        }
        .play-area .video-info .ui-button + .ui-button {
            margin-left: 0.15rem;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/player.vue